import dayjs from 'dayjs';
import React from 'react';
import { Formik, Form } from 'formik';
import * as Yup from 'yup';

import { CircularProgress, Grid } from '@mui/material';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';

import { Button, TextField, Typography } from 'shared';
import { activityFiltersStyles } from 'components/Inventory/style/style';

const initialValues = {
    description: '',
    startDate: null,
    endDate: null,
};

const validationSchema = Yup.object({
    endDate: Yup.date().nullable(),
    startDate: Yup.date().nullable(),
    description: Yup.string().nullable(),
});

const PurchaseAiAgentMatchingFilters = ({ handleFiltersSubmit, isMakingMatches }) => {
    const classes = activityFiltersStyles();

    const handleClearClick = (handleReset) => {
        handleReset();
        handleFiltersSubmit({});
    };

    const handleFormSubmit = (values) => {
        const filters = {
            ...values,
            startDate: values.startDate ? dayjs(values.startDate).format('YYYY-MM-DD') : null,
            endDate: values.endDate ? dayjs(values.endDate).format('YYYY-MM-DD') : null,
            description: values.description,
        };
        handleFiltersSubmit(filters);
    };

    return (
        <Formik
            onSubmit={handleFormSubmit}
            validationSchema={validationSchema}
            initialValues={initialValues}
        >
            {({ values, handleReset, handleChange, setFieldValue }) => {
                return (
                    <Form>
                        <Grid container spacing={1} alignItems="center">
                            {/* <Grid item xs={12} md={4} lg={3}>
                                <TextField
                                    fullWidth
                                    name="description"
                                    inlineLabel="Search"
                                    value={values.description}
                                    placeholder="Search details..."
                                    onChange={handleChange}
                                    customStyle={classes.inputField}
                                />
                            </Grid> */}

                            <Grid item xs={4} md={2} lg={2}>
                                <LocalizationProvider dateAdapter={AdapterDayjs}>
                                    <DatePicker
                                        value={values.startDate && dayjs(values.startDate)}
                                        onChange={(date) => setFieldValue('startDate', date)}
                                        label="Start Date"
                                        placeholder="Start Date"
                                        format="MM-DD-YYYY"
                                        sx={classes.datePicker}
                                    />
                                </LocalizationProvider>
                            </Grid>

                            <Grid item xs={4} md={2} lg={2}>
                                <LocalizationProvider dateAdapter={AdapterDayjs}>
                                    <DatePicker
                                        value={values.endDate && dayjs(values.endDate)}
                                        onChange={(date) => setFieldValue('endDate', date)}
                                        label="End Date"
                                        placeholder="End Date"
                                        format="MM-DD-YYYY"
                                        sx={classes.datePicker}
                                    />
                                </LocalizationProvider>
                            </Grid>
                        </Grid>

                        <Grid
                            mt={2}
                            container
                            spacing={2}
                            alignItems="center"
                            justifyContent="flex-end"
                        >
                            {isMakingMatches && (
                                <Grid item sx={{ display: 'flex', alignItems: 'center' }}>
                                    <CircularProgress size={16} sx={{ marginRight: '8px' }} />
                                    <Typography text="Making matches" variant="body2" />
                                </Grid>
                            )}
                            <Grid item>
                                <Button
                                    text="Clear"
                                    onClick={() => handleClearClick(handleReset)}
                                    customStyles={classes.clearButton}
                                />
                            </Grid>
                            <Grid item>
                                <Button text="Apply" type="submit" />
                            </Grid>
                        </Grid>
                    </Form>
                );
            }}
        </Formik>
    );
};

export default PurchaseAiAgentMatchingFilters;
